export var GENESYS_REGIONS = [{
  key: 'americas-canada',
  name: 'Americas (Canada)',
  targetEnv: 'prod-cac1',
  hostOrigin: 'https://cac1.pure.cloud'
}, {
  key: 'americas-saopaulo',
  name: 'Americas (São Paulo)',
  targetEnv: 'prod-sae1',
  hostOrigin: 'https://sae1.pure.cloud'
}, {
  key: 'americas-us-east',
  name: 'Americas (US East)',
  targetEnv: 'prod',
  hostOrigin: 'https://mypurecloud.com'
}, {
  key: 'americas-us-west',
  name: 'Americas (US West)',
  targetEnv: 'prod-usw2',
  hostOrigin: 'https://usw2.pure.cloud'
}, {
  key: 'apac-mumbai',
  name: 'Asia Pacific (Mumbai)',
  targetEnv: 'prod-aps1',
  hostOrigin: 'https://aps1.pure.cloud'
}, {
  key: 'apac-osaka',
  name: 'Asia Pacific (Osaka)',
  targetEnv: 'prod-apne3',
  hostOrigin: 'https://apne3.pure.cloud'
}, {
  key: 'apac-seoul',
  name: 'Asia Pacific (Seoul)',
  targetEnv: 'prod-apne2',
  hostOrigin: 'https://apne2.pure.cloud'
}, {
  key: 'apac-sydney',
  name: 'Asia Pacific (Sydney)',
  targetEnv: 'prod-apse2',
  hostOrigin: 'https://mypurecloud.com.au'
}, {
  key: 'apac-tokyo',
  name: 'Asia Pacific (Tokyo)',
  targetEnv: 'prod-apne1',
  hostOrigin: 'https://mypurecloud.jp'
}, {
  key: 'emea-dublin',
  name: 'EMEA (Dublin)',
  targetEnv: 'prod-euw1',
  hostOrigin: 'https://mypurecloud.ie'
}, {
  key: 'emea-frankfurt',
  name: 'EMEA (Frankfurt)',
  targetEnv: 'prod-euc1',
  hostOrigin: 'https://mypurecloud.de'
}, {
  key: 'emea-london',
  name: 'EMEA (London)',
  targetEnv: 'prod-euw2',
  hostOrigin: 'https://euw2.pure.cloud'
}, {
  key: 'emea-uae',
  name: 'EMEA (UAE)',
  targetEnv: 'prod-mec1',
  hostOrigin: 'https://mec1.pure.cloud'
}, {
  key: 'emea-zurich',
  name: 'EMEA (Zurich)',
  targetEnv: 'prod-euc2',
  hostOrigin: 'https://euc2.pure.cloud'
}, {
  key: 'fedramp',
  name: 'FedRAMP',
  targetEnv: 'fedramp-use2-core',
  hostOrigin: 'use2.us-gov-pure.cloud'
}];
// The region <select> stores the bare hostname (no scheme); strip it in one place so the
// default value and the option list can never disagree.
export var genesysRegionHost = function (region) {
  return region.hostOrigin.replace(/^https?:\/\//, '');
};
export var DEFAULT_GENESYS_REGION_HOST = genesysRegionHost(GENESYS_REGIONS[0]);